import { render } from "./Produkte.vue?vue&type=template&id=2cb32b50&scoped=true"
import script from "./Produkte.vue?vue&type=script&lang=js"
export * from "./Produkte.vue?vue&type=script&lang=js"

import "./Produkte.vue?vue&type=style&index=0&id=2cb32b50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.12_vue@3.5.12_typescript@5.6.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb32b50"]])

export default __exports__